export const COIN_ARR_NUMBER = [
  1,1,1,1,
  5,5,
  10,10,
  15,15,
  20,20,
  25,25,
  30,30,
  35,35,
  40,40,
  45,45,
]